import React, { FC } from 'react';
import { Modal, Button } from 'antd';
import './outOfBoundsModal.scss';

interface OutOfBoundsModalProps {
    visible: boolean;
    onClose: () => void;
    // Per-site message; falls back to the generic health-and-safety text.
    // eslint-disable-next-line react/require-default-props
    message?: string | null;
}

const DEFAULT_MESSAGE = 'We want to inform you that there is currently a health and safety issue at this site.'
    + ' You can still book a request.';

const OutOfBoundsModal: FC<OutOfBoundsModalProps> = ({ visible, onClose, message }) => (
    <Modal
        title="Site Out of Bounds"
        open={visible}
        onCancel={onClose}
        footer={null}
        centered
        width={560}
        wrapClassName="out-of-bounds-modal">
        <p className="modal-message">
            {message || DEFAULT_MESSAGE}
        </p>
        <div className="modal-buttons">
            <Button
                type="primary"
                className="ok-button"
                onClick={onClose}>
                OK
            </Button>
        </div>
    </Modal>
);

export default OutOfBoundsModal;
